export class ChRequestTypes {

  static PkChangeDiadocFolderInCards = "1DFF1F94-531D-4B6E-A6AA-78AFEB026929";
  static SendMailIntoSupport = "DA59F130-84B0-4E66-90C8-A42C506FD01F";
  static ArActContractPartnersForFlag = "6D57AD72-87DF-4C20-9256-9B203C250B97";
  static GetRegionCityAndProjectByObject = "4C90AAE7-AA20-4A4C-80B0-FB9412107BE6";
  static ArActContractArticleOhr = "DC143C58-31ED-47A3-AC6F-55AC1C3AAA30";
  static ArActContractArticleIdp = "618C013B-C7E1-4FD8-817B-C473ADE6ACB9";
  static PkGetBookkeepers = "919C1F1E-B53C-4DED-8B94-FE441D80BD94";
  static ArDocumentIDPVirtualInfo = "664940FD-44F8-4FD6-BE91-1883359C6351";
  static ArDocumentKind = "EB01185C-1EEA-47CE-A3F9-1E7B5BE8193E";
  static GetCaseOfTheTopLevel = "2D0CA46B-6C82-4E2A-AAC6-0ECB78E86C93";
  static GetInstructionUrl = "A4146DC3-FF46-4B3A-8BA1-BEE35322B3A7";
  static PkProtocolAssignmentTable = "4A67E514-F5A0-4CA1-A8CD-E74C61A18EB0";
  static GetIsAdministrator = "C7399F82-1D49-4A3B-808F-11118AF29B75";
  static GetCrmDeal = "B0409732-D624-4D53-97FB-8C4629171CD9";
  static GetPacketDocsInfo = "33063FD5-FDF3-44CD-8D27-BF030DCB3EB8";
  static PkOutgoingMailSenderRequest = "EFDBAB98-7517-40F1-9539-DB19A4306D02";
  static PkGetExecutionDateByDocKind = "1B484AE3-25E1-473B-8AF3-74C92BE7ACF2";
  static CheckUserInRole = "27458E64-F356-4BB7-9F99-7C96A05F24FB";
  static PkProtocolGetRole = "9D21500A-1E9F-4C71-9228-D8A78032ADB5";
  static GetPayerByContract = "D423A0C4-C578-486E-80FF-F8B1C2F91FF1";
  static ChUpdateOutgoingStamp = "9B0F9F11-4C61-408E-8A59-C334391A6F67";
  static AttachCorrespondencePrintForm =  "77A9F5B1-BB3E-4931-A8BA-CB65B125EA9D";
  static ChSendEmailNotificationToClient = "EE856DC2-C812-43A3-AB32-75F9314A2B39";
  static PkUpdateDataInMDS = "9C489DCE-15DD-402B-8021-0AEF018C87BC";
}